import returnStateName from '../general/returnStateName';
import returnPinCoordinateForState from './returnPinCoordinateForState';

/**
 * Updates our map with state fill color & location pin
 * @param {String} customStateCode - State code of user's location
 * @param {String} fillColor - Fill color for the active state
 */

export default function updateMapWithGeoData(customStateCode = null, fillColor = '#3F88C5') {
	const geolocationState = window.geolocation?.currentLocation?.state,
		state = customStateCode != null ? returnStateName(customStateCode) : geolocationState,
		statecode = customStateCode != null ? customStateCode : window.geolocation?.currentLocation?.statecode;

	if (state) {
		const formattedState = state.toLowerCase().split(' ').join('-');
		const $stateSvgElems = document.querySelectorAll('.svg-map');
		if (window.prevColouredState) {
			$stateSvgElems.forEach(map => {
				const $prevEl = map.querySelector(`#${window.prevColouredState} path`);
				if ($prevEl) {
					$prevEl.style.fill = '#C7C7C7';
				}
			});
		}
		if ($stateSvgElems.length) {
			$stateSvgElems.forEach(map => {
				const $stateSvgEle = map.querySelector(`#${formattedState} path`);
				const $pinElement = map.querySelector('#pin');

				if ($stateSvgEle) {
					$stateSvgEle.style.fill = fillColor;

					if ($pinElement) {
						$pinElement.style.opacity = 1;
						const coords = returnPinCoordinateForState(statecode);
						$pinElement.setAttribute('x', coords.x);
						$pinElement.setAttribute('y', coords.y);
					}
				}
			});
			window.prevColouredState = formattedState;
		} else {
			window.prevColouredState = null;
		}
	}
}
